export default function mapPagination(data){
    return {
        total: data.count,
        per_page: data.per_page,
        current_page: data.page,
        last_page: data.total_pages,
        from: data.offset,
        to: data.offset+data.per_page,
    }
}
